var _excluded = ["apiHost", "organizationId", "onResolve", "onSubmit", "question", "url", "apiKey"];

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React, { useRef } from 'react';
import root from 'react-shadow/styled-components';
import { Provider as OrgProvider } from '../../context/org';
import { Provider as UserProvider } from '../../context/user';
import SingleQuestion from '../Question';
import { Theme } from '../Theme';
export var Question = function Question(_ref) {
  var apiHost = _ref.apiHost,
      organizationId = _ref.organizationId,
      onResolve = _ref.onResolve,
      onSubmit = _ref.onSubmit,
      question = _ref.question,
      url = _ref.url,
      apiKey = _ref.apiKey,
      other = _objectWithoutPropertiesLoose(_ref, _excluded);

  var containerRef = useRef();
  return /*#__PURE__*/React.createElement(root.div, {
    ref: containerRef
  }, /*#__PURE__*/React.createElement(OrgProvider, {
    value: {
      organizationId: organizationId,
      apiHost: apiHost
    }
  }, /*#__PURE__*/React.createElement(UserProvider, null, /*#__PURE__*/React.createElement(Theme, {
    containerRef: containerRef
  }), /*#__PURE__*/React.createElement("div", {
    className: "squeak"
  }, /*#__PURE__*/React.createElement(SingleQuestion, {
    apiHost: apiHost,
    replies: question === null || question === void 0 ? void 0 : question.replies,
    question: question === null || question === void 0 ? void 0 : question.question,
    onSubmit: onSubmit,
    onResolve: onResolve
  })))));
};